import React from "react";
import Portal from "../components/Portal";

function PortalPage() {
  return (
    <>
      <Portal />
    </>
  );
}

export default PortalPage;